import React, { Fragment, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';

import { USER_CART_ITEMS } from './cart';
import { ADD_TO_CART } from './category';
import Header from '../components/header';
import Footer from '../components/footer';
import Spinner from 'react-spinkit';

const GET_SINGLE_PRODUCT = gql`
  query GET_SINGLE_PRODUCT($productId: String) {
    product(productId: $productId) {
      id
      name
      description
      price
      image_url
      category {
        name
      }
    }
  }
`;
const Single = () => {
  const { productId } = useParams();
  const [quantity, setQuantity] = useState(1);

  const [addToCart, { loading: mutationLoading }] = useMutation(ADD_TO_CART);

  const addItemToCart = async (product) => {
    try {
      const response = await addToCart({
        variables: {
          productId: product.id,
          quantity: 1
        },
        update: (cache, { data: { addToCart } }) => {
          const data = cache.readQuery({ query: USER_CART_ITEMS });
          const index = data.cart.findIndex(item => {
            return item.id === addToCart.id
          });
          if (index !== -1) {
            data.cart.map(item => {
              if (item.id === addToCart.id) {
                item.quantity += 1;
              }
            })
          } else {
            data.cart.push(addToCart);
          }
          cache.writeQuery({ query: USER_CART_ITEMS, data });
        }
      });
    } catch (err) {
      console.log(err.message);
    }
  }

  const handleChange = (e) => {
    e.preventDefault();
    setQuantity(e.target.value);
  }

  const { loading, error, data } = useQuery(GET_SINGLE_PRODUCT, {
    variables: {
      productId
    }
  });
  if (loading) return (<Spinner name="circle" />);
  if (error) return "Error!!!";
  return (

    <Fragment>
      <Header />
        <div className="details">
          <figure>
            <img src={data.product.image_url} alt="" className="details__img" />
          </figure>
          <div className="details__description">
            <h2 className="details__description--name">
              {data.product.name}
            </h2>
            <p className="details__description--price">${data.product.price}</p>
            <p className="details__description--text">
              {data.product.description}
            </p>
            <div className="details__description--button">
              <input type="number" name="quantity" onChange={handleChange} value={quantity} min="1" id=""/>
              <button className="btn" onClick={() => addItemToCart(data.product)}>Add{mutationLoading && 'ing'} To Cart</button>
            </div>
          </div>
        </div>
      <Footer />
    </Fragment>
   );
}

export default Single;